import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { useAppAction } from "../../hooks/redux.js";
import { ScrollArea } from "@mantine/core";
import { CodeEditor } from "../../components/CodeEditor.js";
import { Event } from "../../constants/events.js";
import { changeSourceConfig } from "../../reducers/sourcesReducer.js";
import { useStyleEditor } from "../../components/StyleEditorContext.js";
import { SourceConfigHeader } from "./SourceConfigHeader.js";
import { SourceConfigFooter } from "./SourceConfigFooter.js";
import { SecondaryPanel } from "../../components/SidePanel.js";
export const SourceConfigCode = ({ sourceId, source }) => {
    const { captureEvent } = useStyleEditor();
    const changeSource = useAppAction(changeSourceConfig);
    const handleChange = useCallback((value) => {
        if (!value)
            return;
        const updatedSource = JSON.parse(value);
        captureEvent(Event.ChangeSourceConfig, {
            id: sourceId,
        });
        changeSource({
            id: sourceId,
            config: updatedSource,
        });
    }, [sourceId, changeSource, captureEvent]);
    return (_jsxs(SecondaryPanel, { children: [_jsx(SourceConfigHeader, { sourceId: sourceId }), _jsx(ScrollArea, { flex: "1", mih: 0, children: _jsx(CodeEditor, { onChange: handleChange, value: JSON.stringify(source, null, 2) }) }), _jsx(SourceConfigFooter, {})] }));
};
